module.exports = __webpack_public_path__ + "static/shu-28d0e2e6840b15c8e8670cf2b07c1928.svg";